'use strict'

// import Api from '@/api/analytics.js'

const state = {
  loading: false,
  error: null,
  vacanciesTable: null,
  sorting: {
    numberColumn: null,
    order: 'desc'
  }
}

const isNotNull = v => v !== undefined && v !== null

const actions = {
  fetch ({ commit, dispatch }, params) {
    commit('fetch')

    const sorting = state.sorting

    if (isNotNull(sorting.numberColumn)) {
      params['sort_by'] = sorting.numberColumn
      params['sort_order'] = sorting.order
    }

    /*
    return Api.fetchVacanciesTable(params)
      .then(res => commit('fetchSuccess', res))
      .catch(err => {
        dispatch('global/setError', err, { root: true })
        commit('fetchFailure', err)
      })
    */
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, res) {
    state.vacanciesTable = res
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
  },

  updateSorting (state, data) {
    Object.assign(state.sorting, data)
  }
}

const getters = {
  vacanciesTable: (state) => state.vacanciesTable,
  sorting: (state) => state.sorting,
  loading: (state) => state.loading
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
